module.exports = __webpack_public_path__ + "static/media/Intersection 20.1282694d.png";